import React, { useEffect , useState} from "react";
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import { useTranslation } from 'react-i18next';
import ListSaveToForm from '../forms/ListSaveToForm'

function ListFormModal(props) {

  useEffect(() => {
      setShow(props.show);
  }, [props.show]);

  const [show, setShow] = useState(false);
  const { t } = useTranslation();

  const handleFormSubmit = (reloadData,showAddListModal) => {
    props.handleModalOpenClose(reloadData,showAddListModal)
  }

  return (

      <Modal
        animation={true}
        show={show }
        onHide={() => props.handleModalOpenClose(false) }
        backdrop="static"
        size="md"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <h2>{props.list_id ? t('Move requirement to list') : 1 === props.req_ids.length ? t('Save requirement to list') : t('Save requirements to list') }</h2>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ListSaveToForm list_id={props.list_id} req_ids={props.req_ids} onSuccessfulFormSubmit={handleFormSubmit}/>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => props.handleModalOpenClose(false)}>
            {t('Close')}
          </Button>
        </Modal.Footer>
      </Modal>

  );
}

export default ListFormModal
